import {useState} from 'react'
import {secondsToTimeObj,addZero} from '../../util/datetime'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'

const TimeInputGroup = ({value,onChange})=>{
	const [localMinutes,setLocalMinutes] = useState(secondsToTimeObj(value).minutes)
	const [localSeconds,setLocalSeconds] = useState(secondsToTimeObj(value).seconds)

	const handleChangeMinutes = e => {
		const minutes = parseInt(e.target.value) || 0
		setLocalMinutes(minutes)
		const newValue = minutes*60 + localSeconds
		onChange(newValue)
	}

	const handleChangeSeconds = e => {
		const seconds = parseInt(e.target.value) || 0
		setLocalSeconds(seconds)
		const newValue = localMinutes*60 + seconds
		onChange(newValue)
	}

	return (
		<div>
			<InputGroup>
				<Form.Control 
					className="text-center"
					onChange={handleChangeMinutes}
					value={localMinutes}
					placeholder="minutes"
				/>
				<Form.Control 
					className="text-center"
					onChange={handleChangeSeconds}
					value={localSeconds}
					placeholder="seconds"
				/>
			</InputGroup>
			<div className="d-flex text-info text-center justify-content-around">
				<small>minutes</small>
				<small>seconds</small>
			</div>
		</div>
	)
}

const StandardInput = ({value,onChange})=>{
	return (
		<Form.Control onChange={(e)=>{onChange(e.target.value)}} value={value} placeholder="value"/>
	)
}

const DataInput = ({unit,value,onChange})=>{
	if ( unit === 2 ) return <TimeInputGroup value={value} onChange={onChange}/>
	return <StandardInput value={value} onChange={onChange}/>
}

export default DataInput